import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Loader2 } from "lucide-react";

const STEPS = [
  "Fetching channel information...",
  "Loading recent videos...",
  "Calculating statistics...",
  "Running AI analysis...",
  "Finalizing your report...",
];

export default function LoadingSequence() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => Math.min(v + 1, STEPS.length - 1)), 2200);
    return () => clearInterval(t);
  }, []);
  return (
    <div
      data-testid="loading-sequence"
      className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center"
    >
      <div className="relative">
        <div className="absolute inset-0 blur-3xl bg-primary/20 rounded-full animate-pulse" />
        <div className="relative w-20 h-20 rounded-2xl border border-border bg-card flex items-center justify-center">
          <Loader2 className="w-8 h-8 text-primary animate-spin" />
        </div>
      </div>
      <div className="mt-10 min-h-[3rem]">
        <AnimatePresence mode="wait">
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.35 }}
            className="text-xl sm:text-2xl font-bold tracking-tight"
          >
            {STEPS[i]}
          </motion.div>
        </AnimatePresence>
        <div className="mt-3 text-xs uppercase tracking-[0.25em] text-muted-foreground font-mono">
          Step {i + 1} of {STEPS.length}
        </div>
      </div>
      <div className="mt-8 w-full max-w-md h-1 bg-secondary rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-primary"
          initial={{ width: "10%" }}
          animate={{ width: `${((i + 1) / STEPS.length) * 100}%` }}
          transition={{ duration: 0.6 }}
        />
      </div>
    </div>
  );
}
